export default __webpack_public_path__ + "assets/apple-touch-icon-75df813.png";